
import { Component, Prop, Vue } from "nuxt-property-decorator";
import { RawLocation } from "vue-router";

@Component({})
export default class RouterLink extends Vue {
  @Prop({ required: true }) readonly href!: RawLocation;
  @Prop({ required: true }) readonly title!: string;
  @Prop({ default: "_self" }) readonly target!: string;
  @Prop({ default: "default" }) readonly variant!: string;
  @Prop({ default: "default" }) readonly color!: string;
  @Prop({ default: false }) readonly underline!: boolean;
  @Prop({ default: false }) readonly externalLink!: boolean;

  get computedRel(): string | undefined {
    if (!this.externalLink) return undefined;
    if (this.target !== "_blank") return undefined;
    return "noopener noreferrer";
  }

  // Pass an object so Nuxt's router.resolve patch does not call ufo.normalizeURL
  get to(): RawLocation {
    return typeof this.href === "string" ? { path: this.href } : this.href;
  }
}
